var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',[_c('keep-alive',[_c('button',{staticClass:"tw-btn",class:{
                'tw-btn--active': _vm.active,
                'tw-btn--lg': _vm.standalone,
                'tw-btn--xs': !_vm.standalone,
                'tw-btn--info' : !_vm.isSoldOut,
                'tw-btn--danger': _vm.isSoldOut
            },style:({
                'margin-top': '10px',
                'width': _vm.standalone ? '70px' : ''
            }),attrs:{"type":"button","disabled":_vm.isSoldOut},on:{"click":function($event){return _vm.updateSelectedTimeSlot()}}},[_vm._v("\n            "+_vm._s(_vm.timeSlot)+"\n        ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }